const GET_COST_CENTERS = 'GET_COST_CENTERS';
const SET_COST_CENTERS = 'SET_COST_CENTERS';
const GET_COST_CENTER_GROUPS = 'GET_COST_CENTER_GROUPS';
const SET_COST_CENTER_GROUPS = 'SET_COST_CENTER_GROUPS';
const GET_COST_CENTER_BY_REGION = 'GET_COST_CENTER_BY_REGION';
const SET_COST_CENTER_BY_REGION = 'SET_COST_CENTER_BY_REGION';
const GET_COST_CENTER_BY_GROUP = 'GET_COST_CENTER_BY_GROUP';
const SET_COST_CENTER_BY_GROUP = 'SET_COST_CENTER_BY_GROUP';
const SET_COSTCENTER_WITH_DIVISIONID = 'SET_COSTCENTER_WITH_DIVISIONID'
const GET_BULK_ORDER_COST_CENTER = 'GET_BULK_ORDER_COST_CENTER';
const SET_BULK_ORDER_COST_CENTER = 'SET_BULK_ORDER_COST_CENTER';
const GET_COST_CENTERS_BY_BRANCH = 'GET_COST_CENTERS_BY_BRANCH'
const SET_COST_CENTERS_BY_BRANCH = 'SET_COST_CENTERS_BY_BRANCH'

const GET_COST_CENTER_BY_SEARCH_STRING = 'GET_COST_CENTER_BY_SEARCH_STRING'
const SET_COST_CENTER_BY_SEARCH_STRING = 'SET_COST_CENTER_BY_SEARCH_STRING'

export {
    GET_COST_CENTERS,
    SET_COST_CENTERS,
    GET_COST_CENTER_GROUPS,
    SET_COST_CENTER_GROUPS,
    GET_COST_CENTER_BY_REGION,
    SET_COST_CENTER_BY_REGION,
    GET_COST_CENTER_BY_GROUP,
    SET_COST_CENTER_BY_GROUP,
    SET_COSTCENTER_WITH_DIVISIONID,
    GET_BULK_ORDER_COST_CENTER,
    SET_BULK_ORDER_COST_CENTER,
    GET_COST_CENTERS_BY_BRANCH,
    SET_COST_CENTERS_BY_BRANCH,
    GET_COST_CENTER_BY_SEARCH_STRING,
    SET_COST_CENTER_BY_SEARCH_STRING
};
